module.exports = __webpack_public_path__ + "img/icon-easy.b2525b11.svg";